import classNames from 'classnames';
import { Icon, USER_INTERFACE_EQUALIZER_ROTATED } from '@bwoty-web/styleguide';
import PropTypes from 'prop-types';

import styles from './SortingBar.scss';

export const SortingBar = (props) => {
  const { active, dateSortLabel, priceSortLabel, filterLabel, onSortClick, onOpenFilters } = props;

  return (
    <div className={styles.root}>
      <button className={styles.filtersButton} onClick={onOpenFilters} type="button">
        <Icon path={USER_INTERFACE_EQUALIZER_ROTATED} size="xs" />
        {filterLabel}
      </button>
      <div className={styles.options}>
        <button
          className={classNames(styles.option, { [styles.selected]: active !== 'PRICE' })}
          onClick={onSortClick}
          type="button"
          value="DATE"
        >
          {dateSortLabel}
        </button>
        <button
          className={classNames(styles.option, { [styles.selected]: active === 'PRICE' })}
          onClick={onSortClick}
          type="button"
          value="PRICE"
        >
          {priceSortLabel}
        </button>
      </div>
    </div>
  );
};

SortingBar.propTypes = {
  active: PropTypes.string,
  dateSortLabel: PropTypes.node,
  priceSortLabel: PropTypes.node,
  filterLabel: PropTypes.node,
  onSortClick: PropTypes.func,
  onOpenFilters: PropTypes.func,
};
